<template>
  <pt-link-manage-table class="pt-link-manage-table__withData" @getTableData="getTableData" :pageSize="pageSize" :totalNumber="totalNumber"
  :tableLabels="tableLabels" :tableData="tableData" :loading="loading" ref="table">
  <slot/>
  </pt-link-manage-table>
</template>

<script>
import PtLinkManageTable from './index'
export default {
  name: 'pt-link-manage-table__withData',
  components: {
    'pt-link-manage-table': PtLinkManageTable
  },
  props: {
    pageSize: {
      type: Number,
      default: 10
    },
    tableLabels: Array,
    paramsData: Object
  },
  data () {
    return {
      totalNumber: 0,
      loading: false,
      tableData: []
    }
  },
  watch: {
    paramsData: {
      handler: function (val) {
        if (!this.isFromRouter) {
          this.$refs.table.resetPage()
        } else {
          this.isOutside = true
          this.getGoodsList(this.page)
        }
      },
      deep: true
    }
  },
  methods: {
    getTableData (page, next) {
      let data = {
        ...this.paramsData,
        pageableParam: {
          page: page,
          size: this.pageSize
        }
      }
      if (!next) {
        this.loading = true
      }
      this.$store.dispatch('linkTrackOfAll', data).then(res => {
        this.totalNumber = res.totalNumber
        this.tableData = res.data
        if (next) {
          next(res.data)
        }
        this.loading = false
      }).catch(err => {
        this.$message.error(err || '获取链接列表失败')
        this.$refs.table.showReTry()
        this.loading = false
      })
    }
  }
}
</script>
